import { Link } from 'react-router-dom';

const thumbImages = [
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20character%20illustration%20closeup%2C%20clean%20style%2C%20simple%20cream%20background%2C%20warm%20tone%2C%20Korean%20comic%20art%2C%20expressive%20face%2C%20minimal%20composition&width=200&height=260&seq=hanman-cta-thumb-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20male%20character%20portrait%20illustration%2C%20clean%20style%2C%20simple%20cream%20background%2C%20soft%20lighting%2C%20Korean%20comic%20art%2C%20handsome%20face%2C%20minimal%20composition&width=200&height=260&seq=hanman-cta-thumb-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20female%20character%20portrait%20illustration%2C%20clean%20style%2C%20simple%20cream%20background%2C%20soft%20lighting%2C%20Korean%20comic%20art%2C%20beautiful%20face%2C%20minimal%20composition&width=200&height=260&seq=hanman-cta-thumb-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20character%20portrait%20illustration%2C%20clean%20style%2C%20simple%20cream%20background%2C%20dynamic%20pose%2C%20Korean%20comic%20art%2C%20intense%20expression%2C%20minimal%20composition&width=200&height=260&seq=hanman-cta-thumb-04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20character%20portrait%20illustration%2C%20clean%20style%2C%20simple%20cream%20background%2C%20elegant%20look%2C%20Korean%20comic%20art%2C%20noble%20expression%2C%20minimal%20composition&width=200&height=260&seq=hanman-cta-thumb-05&orientation=portrait',
];

export default function CTASection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6 lg:px-10 text-center">
        <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 mb-3">
          准备好开始您的<strong>韩漫</strong>之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-xl mx-auto">
          数千部精选<strong>韩国漫画免费</strong>阅读，每日更新，随时随地畅享精彩故事
        </p>
        <Link
          to="/category/love"
          className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-primary-500 text-background-50 px-8 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors"
        >
          立即开始阅读 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </Link>

        <div className="mt-12 flex justify-center gap-4 md:gap-8 flex-wrap">
          {thumbImages.map((src, n) => (
            <div key={n} className="w-16 h-20 md:w-20 md:h-24 rounded-lg overflow-hidden bg-background-100">
              <img
                src={src}
                alt={`韩漫角色 ${n + 1}`}
                title="韩漫大全 韩国漫画角色"
                className="w-full h-full object-cover object-top"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}